import React from 'react';
import { FaUsers, FaCode, FaLaptopCode, FaGoogle } from 'react-icons/fa';
import { FadeIn } from './animations/MotionPrimitives';
import './styles/Leadership.css';

const COMMUNITIES = [
  { icon: <FaCode aria-hidden="true" />, name: 'Rewriting the Code' },
  { icon: <FaLaptopCode aria-hidden="true" />, name: 'CodePath' },
  { icon: <FaGoogle aria-hidden="true" />, name: 'Google Developer Student Club' },
];

function Leadership() {
  return (
    <section className="section leadership" id="leadership">
      <div className="section-inner">
        <FadeIn className="chapter-head leadership-head">
          <span className="chapter-mark">05</span>
          <h2 className="chapter-title">Leadership &amp; Community</h2>
        </FadeIn>

        <div className="leadership-grid">
          <FadeIn className="leadership-primary" delay={0.05}>
            <span className="leadership-icon" aria-hidden="true">
              <FaUsers />
            </span>
            <div>
              <h3 className="leadership-role">Corporate Chair</h3>
              <p className="leadership-org">Society of Women Engineers, Illinois Tech</p>
              <p className="leadership-desc">
                I support professional development, industry engagement, and student
                opportunities through SWE at Illinois Tech. This role reflects my interest in
                community building, career growth, and helping technical students connect with
                industry.
              </p>
            </div>
          </FadeIn>

          <FadeIn className="leadership-side" delay={0.12}>
            <p className="leadership-side-label">Active in technical communities</p>
            <ul className="leadership-communities">
              {COMMUNITIES.map((community) => (
                <li className="leadership-community" key={community.name}>
                  <span className="leadership-community-icon">{community.icon}</span>
                  <span>{community.name}</span>
                </li>
              ))}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}

export default Leadership;
